// Pipe to map a custom field object's type (objectType) to its display label using the CUSTOM_FIELD_OBJECTS constant.
// Usage: {{ obj.objectType | customFieldObjectLabel }}
// This helps display user-friendly labels in templates instead of raw type values.
import { Pipe, PipeTransform } from '@angular/core';
import { CUSTOM_FIELD_OBJECTS } from '../../custom-field/interfaces/custom-field.interface';

@Pipe({ 
  name: 'customFieldObjectLabel', 
  pure: true,
  standalone: true 
})
export class CustomFieldObjectLabelPipe implements PipeTransform {
  // Transforms an objectType string into its display label.
  transform(objectType: string): string {
    const found = CUSTOM_FIELD_OBJECTS.find((obj) => obj.value === objectType);
    return found ? found.label : objectType;
  }
}
